/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from "@angular/common/http";

import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LOCAL_STORAGE, StorageService } from "ngx-webstorage-service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(@Inject(LOCAL_STORAGE) private localStorage: StorageService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get the auth token from the service.
    const authToken = this.localStorage.get("user").token;

    // Clone the request and replace the original headers with
    // cloned headers, updated with the authorization.
    const authReq = req.clone({
      headers: req.headers.set("Authorization", authToken)
    });

    // send cloned request with header to the next handler.
    return next.handle(authReq);
  }
}
